import { __makeTemplateObject, __read, __spread } from "tslib";
import { css, palette2, spacing } from '../../../../foundation';
import { getRcDialogContentSpacings, RcDialogContentClasses } from '../utils';
export var DialogContentStyle = function (props) {
    var size = props.size, dividers = props.dividers;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: ", ";\n    color: ", ";\n\n    &.", " {\n      border-color: ", ";\n    }\n  "], ["\n    padding: ", ";\n    color: ", ";\n\n    &.", " {\n      border-color: ", ";\n    }\n  "])), spacing.apply(void 0, __spread(getRcDialogContentSpacings(dividers)[size])), palette2('neutral', 'f04'), RcDialogContentClasses.dividers, palette2('neutral', 'l02'));
};
var templateObject_1;
